document.addEventListener('DOMContentLoaded', () => {
  const stickyComponent = document.querySelector('sticky-add-to-cart');
  const stickyBar = stickyComponent?.querySelector('[ref="stickyBar"]');

  const normalAddButton =
    document.querySelector('product-form button[type="submit"]') ||
    document.querySelector('button[name="add"]');

  if (!stickyBar || !normalAddButton) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      stickyBar.dataset.stuck = entry.isIntersecting ? 'false' : 'true';
    },
    {
      threshold: 0
    }
  );

  observer.observe(normalAddButton);
});